export default __webpack_public_path__ + "static/media/952.49f904d4.png";